
import config from '../../src/config';

const constants = {};

if (window.location.hostname === "mayoalumni") {
  constants.API_BASE_URL = ''; // Base url
} else {
  constants.API_BASE_URL = config.API_BASE_URL;
  constants.API_BASE_URL_LOCATION = config.API_BASE_URL_LOCATION;
  constants.IMAGE_BASE_URL = config.IMAGE_BASE_URL;
  constants.IMAGE_BASE_URL_WITHOUT_UPLOAD = config.IMAGE_BASE_URL_WITHOUT_UPLOAD;
}

export default constants;
